// @flow
import * as React from 'react';
import {FormattedMessage} from 'react-intl';

const containerStyle = {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  minHeight: '320px',
  padding: '24px',
  textAlign: 'center'
};

/**
 * Shown when neither the master app nor the session JWT could provide a
 * merchant id, so no dispute request can be issued.
 */
const MerchantNotSetError = () => (
  <div data-id="merchant-not-set-error" style={containerStyle}>
    <FormattedMessage id="app.support.disputes.errors.merchant-not-set" />
  </div>
);

export default MerchantNotSetError;
